import React from 'react';
import { Badge, Card, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import StaleAssignmentBanner from './StaleAssignmentBanner';

/**
 * UI-069: view-mode card showing the patient's nurse + case-manager. Consumes
 * the enriched objects returned by GET /patients/get-patient/:id (SL-109) —
 * `nurse` and `case_manager` are full user mini-objects (id, first_name,
 * last_name, email, phone, is_active). When unassigned the slot renders a
 * subtle placeholder so the admin sees the empty state.
 *
 * UD3 (stale display): if the assigned user is inactive, a yellow banner is
 * shown above the card via `StaleAssignmentBanner`.
 */
const StaffRow = ({ label, icon, staff }) => {
  if (!staff) {
    return (
      <Col xs={12} md={6}>
        <div className="d-flex align-items-center gap-2 text-500 fs-11">
          <FontAwesomeIcon icon={icon} />
          <span><strong>{label}:</strong> Not assigned</span>
        </div>
      </Col>
    );
  }
  const name = `${staff.first_name || ''} ${staff.last_name || ''}`.trim() || `User #${staff.id}`;
  const phone = staff.phone || '';
  const email = staff.email || '';
  const inactive = !(staff.is_active === 1 || staff.is_active === '1' || staff.is_active === true);
  return (
    <Col xs={12} md={6}>
      <div className="d-flex align-items-start gap-2">
        <FontAwesomeIcon icon={icon} className="mt-1 text-primary" />
        <div className="flex-grow-1">
          <div>
            <strong>{label}:</strong> {name}
            {inactive && (
              <Badge bg="warning" className="ms-2">Inactive</Badge>
            )}
          </div>
          {phone && (
            <div className="fs-11">
              <a href={`tel:${phone}`} className="text-decoration-none">
                <FontAwesomeIcon icon="phone" className="me-1" />
                {phone}
              </a>
            </div>
          )}
          {email && (
            <div className="fs-11 text-500">
              <FontAwesomeIcon icon="envelope" className="me-1" />
              {email}
            </div>
          )}
        </div>
      </div>
    </Col>
  );
};

const StaffingDisplay = ({ nurse, caseManager, className = '' }) => {
  if (!nurse && !caseManager) return null;
  return (
    <Card className={className}>
      <Card.Body className="py-3">
        <h6 className="mb-3 fw-bold">Shared Living Staffing</h6>
        <StaleAssignmentBanner roleLabel="Nurse" staff={nurse} />
        <StaleAssignmentBanner roleLabel="Case Manager" staff={caseManager} />
        <Row className="g-3">
          <StaffRow label="Nurse" icon="user-nurse" staff={nurse} />
          <StaffRow label="Case Manager" icon="user-tie" staff={caseManager} />
        </Row>
      </Card.Body>
    </Card>
  );
};

export default StaffingDisplay;
